import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "mention-highlight",
  contenteditable: "false"
}
const _hoisted_3 = {
  key: 2,
  class: "while-spaces"
}

import { renderLink, CheckLink, REGEX_HTTP, mentionRegex } from '@/constants/regex'
import { computed } from 'vue'

type MessagePart = {
  isLink?: boolean
  isMention: boolean
  value: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  data: String,
  users: {
    type: Object,
  },
  className: {
    type: String,
    default: '',
  },
  contentDetail: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const getMentionedUserName = (mention: string) => {
  const { users } = props

  const match = mention.match(mentionRegex)
  if (match) {
    const userId = match[1]
    const user = users[userId]

    return user ? `@${user.display_name}` : mention
  }

  return mention
}

const processedText = computed(() => {
  const { data, contentDetail } = props

  const messages = CheckLink(data) || []

  return messages.flatMap((message) => {
    if (REGEX_HTTP.test(message)) {
      return [{ isLink: true, value: message }]
    }

    if (contentDetail) {
      const result: MessagePart[] = []
      const parts = message.split(/(<span class="mention-highlight" contenteditable="false">[\s\S]*?<\/span>)/)
      parts.forEach((part) => {
        // Check if it is a <span> tag then process the content inside
        const spanMatch = part.match(/<span class="mention-highlight" contenteditable="false">([\s\S]*?)<\/span>/)
        if (spanMatch) {
          if (spanMatch[1]) {
            result.push({
              isMention: true,
              value: spanMatch[1],
            })
          }
        } else if (part.trim()) {
          result.push({
            isMention: false,
            value: part,
          })
        }
      })
      return result
    }

    return message.split(mentionRegex).map((part, index) => {
      if (index % 2 !== 0) {
        const userMention = getMentionedUserName(`@{${part}}`)
        const isValidMention = userMention !== `@{${part}}`
        return {
          isMention: isValidMention,
          value: userMention,
        }
      }

      return {
        isMention: false,
        value: part,
      }
    })
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['text-break break-spaces', __props.className])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedText), (text, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (text.isLink)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _unref(renderLink)(text.value)
            }, null, 8, _hoisted_1))
          : (text.isMention)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(text.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(text.value), 1))
      ], 64))
    }), 128))
  ], 2))
}
}

})